import { Fragment } from 'react'
import PriceConverter from '../helpers/PriceConverter'
import ShopSlider from '../search/ShopSlider'
import { FormattedMessage } from 'react-intl'
import { target } from 'utils'

export function OperatorListItem({ item, eCommerceListName }) {
  const handleClick = () => {
    if(item.impression) {
      window.dataLayer.push({
        event: 'productClick',
        ecommerce: {
          currencyCode: 'USD',
          click: {
            actionField: {
              list: eCommerceListName,
            },
            products: [item.impression],
          },
        },
      })
    }
  }
  return (
    <a
      className='operator-item'
      href={item.url}
      target={target}
      onClick={handleClick}
    >
      <div className='img-wrapper'>
        <ShopSlider currentPhotos={item.images} />
        <span
          className={`heart ${item.wishlist ? 'active' : ''}`}
          data-shop-slug={item.slug}
          data-type={item.itemType}
          data-in-wishlist={item.wishlist}
          data-wishlist-id={item.wishlist}
        />
      </div>
      <div className='info'>
        <p className='subtitle'>{item.locationTitle}</p>
        <p className='title'>{item.title}</p>
        {item.description ? (
          <p className='description'>{item.description}</p>
        ) : (
          ''
        )}
      </div>
      {item.minPrice ? (
        <p className='price-from'>
          <FormattedMessage id='from' defaultMessage='From' />
          &nbsp;
          <PriceConverter amount={item.minPrice} currency={item.currency} />
          {item.itemType !== 'GroupTrip' ? (
            <Fragment>
              <br />
              <FormattedMessage
                tagName='i'
                id='per_day'
                defaultMessage='per day'
              />
            </Fragment>
          ) : (
            ''
          )}
        </p>
      ) : (
        ''
      )}
    </a>
  )
}

export function OperatorListItemLoader() {
  return (
    <div className='operator-item placeholder'>
      <div className='img-wrapper' />
      <div className='info'>
        <p className='subtitle' />
        <p className='title' />
        <p className='description' />
      </div>
      <p className='price-from' />
    </div>
  )
}
